import type { GlobalTypes } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

// transactions

export enum EPaymentStatuses {
  // pending
  hold = 'hold',
  new = 'new',
  order_scheduled = 'order_scheduled',
  pending = 'pending',
  sending = 'sending',

  // failed
  failed = 'failed',
  order_failed = 'order_failed',
  descriptor_failed = 'descriptor_failed',
  failed_payout = 'failed_payout',
  failed_exchange = 'failed_exchange',
  limits_exceeded = 'limits_exceeded',
  failed_send = 'failed_send',

  // succeeded
  paid = 'paid',
  completed = 'completed',
  succeeded = 'succeeded',
  sent = 'sent',

  // cancelled
  cancelled = 'cancelled',

  // others
  charged = 'charged',
  order_verified_not_complete = 'order_verified_not_complete',
}

export enum EUserStatuses {
  success = 'success',
  failed = 'failed',
  pending = 'pending',
  cancelled = 'cancelled',
}

export enum TransactionTypesEnum {
  deposit = 'deposit',
  withdraw = 'withdraw',
  buy = 'buy',
  sell = 'sell',
  referral = 'referral',
  card_operation = 'card_operation',
  fiat_buy = 'fiat_buy',
  buy_acquirer = 'buy_acquirer',
  mobile_pay = 'mobile_pay',
  fiat_sell = 'fiat_sell',
  fiat_withdraw = 'fiat_withdraw',
}

export type TransactionsPaymentSystemsType = 'visa' | 'mastercard' | 'maestro' | 'nspkmir';
export type MobilePayType = 'google' | 'apple';

export type GetTransactionsParams = {
  type?: TransactionTypesEnum;
  limit?: number;
  offset?: number;
  total?: boolean;
  currency?: GlobalTypes.CryptoCurrencyEnum;
};

export type TransactionType = {
  id: string;
  created_at: string;
  created_at_ts: number;
  updated_at: string;
  updated_at_ts: number;
  calculated_amount?: string;
  type: TransactionTypesEnum;
  currency: GlobalTypes.CryptoCurrencyEnum;
  amount: string;
  fiat_currency: GlobalTypes.FiatCurrencyEnum;
  fiat_amount: string;
  status: EPaymentStatuses;
  fee?: string;
  trace: {
    trace_id: string;
  };
  mobile_pay?: {
    id: string;
    pay_system: MobilePayType;
    amount: string;
    currency: CryptoCurrencyEnum;
  };
  fee_currency?: GlobalTypes.CurrencyEnum;
  tx?: {
    id: string;
    url: string;
    address: string;
    fee: string;
  };
  card: {
    id: string;
    number: string;
    payment_system: TransactionsPaymentSystemsType;
  };
};

export type GetTransactionsResponse = TransactionType[];

export type TTransactionsObject = { [key: string]: TransactionType };
export type TSortTransactions = { [key: number]: TTransactionsObject };

// referral

export type GetReferralResponse = {
  code: string;
  url: string;
  count: number;
  sum: {
    total: string;
    expected: string;
  };
  monthly: {
    month: string;
    total: string;
    expected: string;
  }[];
};

// referral/transactions

export type ReferralTransactionsTypesType = 'buy' | 'sell' | 'month';
export enum ReferralTransactionsStatusEnum {
  new = 'new',
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
}

export type GetReferralTransactionsParams =
  | {
      type?: ReferralTransactionsTypesType;
      limit?: number;
      offset?: number;
      month?: string;
      currency?: string;
    }
  | undefined;

export type GetReferralTransactionsResponse = {
  id: string;
  created_at: string;
  currency: string;
  amount: string;
  status: ReferralTransactionsStatusEnum;
};

export type GetReferralTransactionsResponseArray = GetReferralTransactionsResponse[];
